import { Injectable } from '@angular/core';
import { RotateCardContentViewModel } from '../../../../base/rotate-card-content-view-model';

@Injectable()
export class PrintCardContentInflatorViewModel extends RotateCardContentViewModel {}
